<script setup>
import pie from './charts/BlockPie.vue';
import bar from './charts/BlockBar.vue';
import {computed} from "vue";

const props = defineProps({
  blockData: Object
})
const dataValues = computed(() => {
  let dataValuesArray = [];
  props.blockData.rows.forEach(function (row) {
    dataValuesArray.push(row.value);
  });
  return dataValuesArray;
})
const chartLabels = computed(() => {
  let chartLabelsArray = [];
  props.blockData.rows.forEach(function (row) {
    chartLabelsArray.push(row.label);
  });
  return chartLabelsArray;
})

const componentMap = {
  pie,
  bar,
}
const component = componentMap[props.blockData.type];
</script>

<template>
  <div>
    <div class="row">
      <div class="col-sm-12" v-html="props.blockData.header"></div>
    </div>
    <component :is="component" v-bind:chartLabels="chartLabels" v-bind:dataValues="dataValues"
               v-bind:axisLabel="props.blockData.axis_label">
    </component>
    <div class="row">
      <div class="col-sm-12" v-html="props.blockData.footer"></div>
    </div>
  </div>
</template>

